module.exports = __webpack_public_path__ + "static/media/pr_02_A.e1a91b82.png";